import React from "react"
import PropTypes from "prop-types"

import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';

const MAX_TEXTAREA_HEIGHT = 120;

class ChatTextArea extends React.Component {
  constructor(props) {
    super(props)

    this.textareaRef = React.createRef();
    this.updateText = this.updateText.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.resizeTextarea = this.resizeTextarea.bind(this)
  }

  componentDidMount() {
    this.resizeTextarea();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.textbox !== this.props.textbox) {
      this.resizeTextarea();
    }
  }

  resizeTextarea() {
    const textarea = this.textareaRef.current;
    if (!textarea) {
      return;
    }

    textarea.style.height = 'auto';
    textarea.style.height = `${Math.min(textarea.scrollHeight, MAX_TEXTAREA_HEIGHT)}px`;
  }

  updateText(event) {
    this.props.updateText(event.target.value);
    this.resizeTextarea();
  }

  sendMessage() {
    if(this.props.textbox != '') {
      this.props.sendMessage(this.props.textbox)
    }
  }

  render() {
    const canSend = this.props.textbox !== '';

    return(
      <div className="chat-panel__composer">
        <div className="chat-panel__composerInner">
          <textarea
            ref={this.textareaRef}
            className="chat-panel__input"
            value={this.props.textbox}
            rows="1"
            onChange={this.updateText}
            placeholder="Type a message..."
          />
          <button
            type="button"
            onClick={() => this.sendMessage()}
            className={`chat-panel__send ${canSend ? 'chat-panel__send--active' : ''}`}
            aria-label="Send message"
            disabled={!canSend}
          >
            <Icon
              name="arrow-up"
              size={20}
              color={canSend ? '#ffffff' : primitives.grey['500']}
            />
          </button>
        </div>
      </div>
    )
  }

}

export default ChatTextArea;
